// @ts-strict-ignore
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'lm-preview-options-dialog',
  templateUrl: './lm-preview-options-dialog.component.html',
  styleUrls: ['./lm-preview-options-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMPreviewOptionsDialogComponent implements OnInit {

  @Input() listNames: Array<{ name: string }>;

  public listNameDropdownAttributes = [ { name: 'data-automation-id', value: 'lm-preview-options-list-name' } ];
  title: string;
  _listName: string;

  get listName(): string {
    return this._listName;
  }

  constructor(public changeDetection: ChangeDetectorRef) { }

  ngOnInit() {
    this.title = Soho.Locale.translate('PreviewDescription');
  }

}
